// tslint:disable: quotemark
export enum PermissionProfileEnum {
	Driver = 0,
	Admin = 1
}

export namespace PermissionProfileEnum {
	export function toDescription(val: PermissionProfileEnum) {
		switch (val) {
			case 0:
				return "Driver";
			case 1:
				return "Admin";
		}
		return null;
	}
}
